export class KVNavyAnnotation {
  // Coating defect types
  coatingLocal: boolean
  coatingGlobal: boolean

  // Corrosion defect types
  corrosionGeneralRust: boolean
  corrosionScaling: boolean
  corrosionPitting: boolean
  corrosionGratingSupport: boolean
  corrosionEquipmentFoundation: boolean
  corrosionNone: boolean
  corrosionOther: boolean

  // Structural defect types
  structuralHoling: boolean
  structuralWeldCrack: boolean
  structuralBuckling: boolean
  structuralDoublerPlate: boolean
  structuralPlateCrack: boolean
  structuralDentCrease: boolean
  structuralFoundationDamaged: boolean
  structuralGratingDamaged: boolean
  structuralStanchionDamaged: boolean
  structuralDrainage: boolean
  structuralOther: boolean

  constructor() {
    // Initialize all defect type booleans to false
    this.coatingLocal = false
    this.coatingGlobal = false
    this.corrosionGeneralRust = false
    this.corrosionScaling = false
    this.corrosionPitting = false
    this.corrosionGratingSupport = false
    this.corrosionEquipmentFoundation = false
    this.corrosionNone = false
    this.corrosionOther = false
    this.structuralHoling = false
    this.structuralWeldCrack = false
    this.structuralBuckling = false
    this.structuralDoublerPlate = false
    this.structuralPlateCrack = false
    this.structuralDentCrease = false
    this.structuralFoundationDamaged = false
    this.structuralGratingDamaged = false
    this.structuralStanchionDamaged = false
    this.structuralDrainage = false
    this.structuralOther = false
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  static fromJSON(json: any): KVNavyAnnotation {
    const annotation = new KVNavyAnnotation()
    // Map defect type booleans
    if (json.coatingLocal !== undefined)
      annotation.coatingLocal = json.coatingLocal
    if (json.coatingGlobal !== undefined)
      annotation.coatingGlobal = json.coatingGlobal
    if (json.corrosionGeneralRust !== undefined)
      annotation.corrosionGeneralRust = json.corrosionGeneralRust
    if (json.corrosionScaling !== undefined)
      annotation.corrosionScaling = json.corrosionScaling
    if (json.corrosionPitting !== undefined)
      annotation.corrosionPitting = json.corrosionPitting
    if (json.corrosionGratingSupport !== undefined)
      annotation.corrosionGratingSupport = json.corrosionGratingSupport
    if (json.corrosionEquipmentFoundation !== undefined)
      annotation.corrosionEquipmentFoundation =
        json.corrosionEquipmentFoundation
    if (json.corrosionNone !== undefined)
      annotation.corrosionNone = json.corrosionNone
    if (json.corrosionOther !== undefined)
      annotation.corrosionOther = json.corrosionOther
    if (json.structuralHoling !== undefined)
      annotation.structuralHoling = json.structuralHoling
    if (json.structuralWeldCrack !== undefined)
      annotation.structuralWeldCrack = json.structuralWeldCrack
    if (json.structuralBuckling !== undefined)
      annotation.structuralBuckling = json.structuralBuckling
    if (json.structuralDoublerPlate !== undefined)
      annotation.structuralDoublerPlate = json.structuralDoublerPlate
    if (json.structuralPlateCrack !== undefined)
      annotation.structuralPlateCrack = json.structuralPlateCrack
    if (json.structuralDentCrease !== undefined)
      annotation.structuralDentCrease = json.structuralDentCrease
    if (json.structuralFoundationDamaged !== undefined)
      annotation.structuralFoundationDamaged = json.structuralFoundationDamaged
    if (json.structuralGratingDamaged !== undefined)
      annotation.structuralGratingDamaged = json.structuralGratingDamaged
    if (json.structuralStanchionDamaged !== undefined)
      annotation.structuralStanchionDamaged = json.structuralStanchionDamaged
    if (json.structuralDrainage !== undefined)
      annotation.structuralDrainage = json.structuralDrainage
    if (json.structuralOther !== undefined)
      annotation.structuralOther = json.structuralOther

    return annotation
  }

  static toJSON(annotation: KVNavyAnnotation): any {
    return {
      // Defect type booleans
      coatingLocal: annotation.coatingLocal,
      coatingGlobal: annotation.coatingGlobal,
      corrosionGeneralRust: annotation.corrosionGeneralRust,
      corrosionScaling: annotation.corrosionScaling,
      corrosionPitting: annotation.corrosionPitting,
      corrosionGratingSupport: annotation.corrosionGratingSupport,
      corrosionEquipmentFoundation: annotation.corrosionEquipmentFoundation,
      corrosionNone: annotation.corrosionNone,
      corrosionOther: annotation.corrosionOther,
      structuralHoling: annotation.structuralHoling,
      structuralWeldCrack: annotation.structuralWeldCrack,
      structuralBuckling: annotation.structuralBuckling,
      structuralDoublerPlate: annotation.structuralDoublerPlate,
      structuralPlateCrack: annotation.structuralPlateCrack,
      structuralDentCrease: annotation.structuralDentCrease,
      structuralFoundationDamaged: annotation.structuralFoundationDamaged,
      structuralGratingDamaged: annotation.structuralGratingDamaged,
      structuralStanchionDamaged: annotation.structuralStanchionDamaged,
      structuralDrainage: annotation.structuralDrainage,
      structuralOther: annotation.structuralOther,
    }
  }
}
